<template>
  <td>
    {{ output.name }}
  </td>
  <td
    class="text-end"
  >
    {{ formatDigit(output.planned_quantity) }}
  </td>
  <td
    class="text-end"
    v-if="['pending', 'progressing'].includes($parent.data.status)"
  >
    <div class="input-group-sm">
      <input
        type="number"
        inputmode="decimal"
        v-model.trim="v$.output.actual_quantity.$model"
        style="font-size: 14px;"
        class="form-control shadow-none text-end"
        :placeholder="$t('Enter actual quantity') + '...'"
        :disabled="$parent.data.status !== 'progressing'"
      >
    </div>
  </td>
  <td
    class="text-end"
    v-if="['completed', 'cancelled'].includes($parent.data.status)"
  >
    {{ formatDigit(output.actual_quantity) }}
  </td>
  <td>
    {{ $t(output.unit) }}
  </td>
</template>

<script lang="js">
import { useVuelidate } from '@vuelidate/core';
import validation from "./assets/template/validation-view-output-form";
import moment from "moment";
import numeral from 'numeral';
import Select2 from 'vue3-select2-component';

export default {
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return validation(this.output)
  },
  props: {
    output: {
      type: Object,
      default: []
    },
    index: {
      type: Number,
      required: true
    }
  },
  data() {
    let vm = this;
    return {
    }
  },
  components: {
    Select2
  },
  methods: {
    formatDigit(value) {
      if ((value < 0.01) && value != 0) {
        return numeral(value).format("0,0.0000");
      }
      return numeral(value).format("0,0.00");
    },
    formatNumber(value) {
      return numeral(value).format("0,0");
    },
    formatNumberTwoDigit(value) {
      return numeral(value).format("0,0.00");
    },
    formatNumberDigit(value) {
      return numeral(value).format("0,0.0000");
    },
  },
  async mounted() {},
  computed: {
  },
  watch: {
    "output.actual_quantity" (nval, oval) {
      // if (this.item.inventory_lot_id !== '' && (nval !== null && nval !== '')) {
      //   this.item.quantity = -Math.abs(nval);
      // }
      // this.item.total_cost = Math.abs(nval) * this.item.cost;
    },
  }
}
</script>
